'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Select", {
    enumerable: true,
    get: function() {
        return Select;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSelect = require("./useSelect");
const _renderSelect = require("./renderSelect");
const _useSelectStylesstyles = require("./useSelectStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Select = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSelect.useSelect_unstable)(props, ref);
    (0, _useSelectStylesstyles.useSelectStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSelectStyles_unstable')(state);
    return (0, _renderSelect.renderSelect_unstable)(state);
});
Select.displayName = 'Select';
